import { FieldNode } from 'graphql';

export const getFieldSelectionFieldNode = (field: FieldNode, subfieldName: string) =>
  field.selectionSet?.selections.find(
    (selection) => selection.kind === 'Field' && selection.name.value === subfieldName,
  );
